export const locale = {
    lang: 'cn',
    data: {
        nav: {
            dashboards: '仪表板',
            customer: '顾客',
            account_users: '用户',
            profiles: '简介',
            trading_accounts: '交易账户',
            accounts: '帐号',
            groups: '组',
            fund_management: '基金管理',
            deposits: '存款',
            withdrawal: '退出',
            funding_methods: '资助方式',
            requests: '要求',
            leverage: '杠杆作用',
            others: '其他',
            monitoring: '监控',
            special_features: '批量操作',
            settings: '设置',
            credit_cards: '信用卡',
            union_pay_cards: '银联卡',
            bank_account: '银行账户',
            black_lists: '黑名单',
            payouts: '赔率',
            notifications: '通知',
            reports: '报告',
            operations: '操作',
            funds: '资金',
            rewards: '奖励',
            custom: '习惯',
            bpay: 'BPay进行',
            account: '帳戶',
            contact: '聯繫',
            system_user: '系統用戶',
        },

        button_name: {
            create: '创建',
            create_and_add: '创建并添加另一个',
            create_and_return: '创建并返回列表',
            update: '更新',
            update_and_close: '更新并关闭',
            delete: '删除'
        },
        login: {
            title: '登录管理系统',
            username: '用户名',
            password: '密码',
            rememberme: '记住账号',
            loginbtn: '登录',
            urequired: '用户名是必需的',
            prequired: '密码是必需的',
            forgot_password: '忘记密码？',
            reset_password_successful: '密码已成功重置。'
        },

        forgot_password: {
            check_email: '查看电子邮件',
            thank_you: '谢谢',
            noticed: '一封电子邮件已经发送至 {{emailRequest}}. 它包含您必须单击以重置密码的链接。',
            recovery_password: '恢复你的密码',
            email_required: '需要电子邮件',
            validate_email: '请输入有效的电子邮件地址',
            send_link: '发送重置链接',
            go_login: '回去登录',
            email: '电子邮件'
        },
        reset_password: {
            reset_your_pass: '重置你的密码',
            email: '电子邮件',
            email_required: '需要电子邮件',
            validate_email: '请输入有效的电子邮件地址',
            password: '密码',
            password_required: '密码是必需的',
            password_confirm: '确认密码）',
            password_confirm_required: '需要密码确认',
            password_confirm_match: '密码必须匹配',
            reset_my_pass: '重置我的密码',
            go_login: '回去登录',
        },
        lock: {
            title: '你的會話被鎖定了',
            content: '由於不活動，您的會話已被鎖定。 輸入您的密碼以繼續',
            unlock: '開鎖'
        }
    }
};
